module.exports = __webpack_public_path__ + "static/media/HMW.5e60f15f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Cooleaf/HMW.png
// module id = 135
// module chunks = 0